import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'

Vue.config.productionTip = false

// Optional. When using scrollOverflow:true
//import 'fullpage.js/vendors/scrolloverflow'

// Optional. When using fullpage extensions
//import './fullpage.scrollHorizontally.min'

import VueFullPage from 'vue-fullpage.js'
import './styles/fullpage.css'

Vue.use(VueFullPage)

new Vue({
    render: h => h(App)
}).$mount('#app')